module.exports = __webpack_public_path__ + "media/ice_shopper_lifetime_metrics/avocado-f32dcdc8.webp";